module.exports = __webpack_public_path__ + "img/CQ(3).5c62d0e0.jpg";